<template>
  <q-page padding>
    <PageHeader
      title="Nova Necessidade de Compra com base no MRP"
      :backRoute="{ name: 'compras-necessidades' }"
      backBehavior="route"
    />

    <div class="q-ml-md">
      <div class="row col-12 text-brand-1 text-weight-bold q-gutter-sm q-mt-md">
        <div class="col-md">
          <div class="q-ml-sm">Unidade</div>
          <lista-unidades-select v-model="unidade"></lista-unidades-select>
        </div>
        <div class="col-md">
          <div class="q-ml-sm">Urgência</div>
          <q-select
            :options="options"
            label="Selecione uma Urgencia"
            dense
            outlined
            behavior="menu"
            v-model="urgencia"
            :rules="[(val) => val || 'Campo Obrigatório']"
          />
        </div>

        <div class="col-md">
          <div class="q-ml-sm">Solicitante</div>
          <SelectSolicitante v-model="solicitante" :vendor-id="unidade?.id" />
        </div>
        <div class="col-md">
          <div class="q-ml-sm">Centro de Custo</div>
          <SelectCentroCustos v-model="centro" />
        </div>
        <div class="col-md">
          <div class="q-ml-sm">Responsável pela Compra</div>
          <SelectSolicitanteCompra
            v-model="responsavel"
            :vendor-id="unidade?.id"
          />
        </div>
      </div>
      <!-- <div class="row col-12 q-mt-md">
        <div
          style="font-size: 16px"
          class="q-mb-sm row col-12 text-brand-1 text-weight-medium"
        >
          <span>Selecione um grupo de produto que desejar.</span>
        </div>
        <div class="row col-12 text-weight-bold q-gutter-sm">
          <div class="col-3 text-brand-1">
            <div class="q-ml-sm">Grupo de Produtos</div>
            <SelectGrupos v-model="grupos" :disable="todos" />
          </div>
          <div>
            <p></p>
            <q-toggle
              class="q-mt-xs text-brand-1"
              left-label
              label="Selecionar Todos"
              v-model="todos"
              color="brand-1"
              @click="grupos = ''"
            />
          </div>
        </div>
      </div>-->
    </div>
    <div
      class="row q-mt-md q-ml-md col-12 text-brand-5"
      style="font-size: 18px"
    >
      <p class="text-brand-1">Filtros</p>
    </div>
    <div class="q-ml-md">
      <div class="row col-12 text-brand-1 text-weight-bold q-gutter-sm">
        <div class="col-md">
          <div class="q-ml-sm">Compra Sugerida</div>
          <q-select
            :options="compraSugerida"
            label="Selecione a Compra Sugerida"
            dense
            outlined
            options-value="value"
            behavior="menu"
            emit-value
            map-options
            v-model="filtrosLista.compra_sugerida"
          />
        </div>
        <div class="col-md">
          <div class="q-ml-sm">Compra em Aberto</div>
          <q-select
            :options="compraAberto"
            label="Selecione a Compra em Aberto"
            dense
            outlined
            emit-value
            options-value="value"
            map-options
            behavior="menu"
            v-model="filtrosLista.compra_em_aberto"
          />
        </div>

        <div class="col-md">
          <div class="q-ml-sm">MRP</div>
          <q-select
            :options="mrpSelect"
            label="Selecione o MRP"
            dense
            outlined
            behavior="menu"
            emit-value
            options-value="value"
            map-options
            v-model="filtrosLista.stock"
          />
        </div>
        <div class="col-md">
          <div class="q-ml-sm">Quantidade de Linhas</div>
          <q-select
            :options="linhasPorPagina"
            label="Selecione a Quantidade de Linhas"
            dense
            outlined
            behavior="menu"
            v-model="pagination.rowsPerPage"
          />
        </div>
      </div>
      <!-- <div class="row col-12 q-mt-md">
        <div
          style="font-size: 16px"
          class="q-mb-sm row col-12 text-brand-1 text-weight-medium"
        >
          <span>Selecione um grupo de produto que desejar.</span>
        </div>
        <div class="row col-12 text-weight-bold q-gutter-sm">
          <div class="col-3 text-brand-1">
            <div class="q-ml-sm">Grupo de Produtos</div>
            <SelectGrupos v-model="grupos" :disable="todos" />
          </div>
          <div>
            <p></p>
            <q-toggle
              class="q-mt-xs text-brand-1"
              left-label
              label="Selecionar Todos"
              v-model="todos"
              color="brand-1"
              @click="grupos = ''"
            />
          </div>
        </div>
      </div>-->
    </div>

    <div class="q-mt-lg">
      <q-table
        flat
        style="max-height: 500px"
        :rows="rows"
        dense
        :columns="columns"
        table-header-style="background-color: #d9effc"
        :loading="disable"
        selection="multiple"
        row-key="product_id"
        color="primary"
        title-class="text-brand-5 text-weight-bold"
        hide-pagination
        class="my-sticky-dynamic"
        v-model:pagination="pagination"
        v-model:selected="produtosSelecionados"
        :rows-per-page-options="[0]"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Selecione os produtos que deseja incluir na necessidade de
            compra</span
          >
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            class="col-md-4"
            v-model="filter"
            placeholder="Pesquisar Produtos"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
      </q-table>

      <div class="row justify-start q-mt-md" v-if="rows.length > 0">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <div v-if="produtosSelecionados.length != 0" class="q-mt-lg">
      <q-table
        flat
        :rows="produtosSelecionados"
        table-header-style="background-color: #d9effc"
        dense
        :columns="columns2"
        class="my-sticky-dynamic"
        title-class="text-brand-5 text-weight-bold"
        :loading="disable"
        :filter="filtrar"
        hide-pagination
        :rows-per-page-options="[0]"
      >
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Produtos Selecionados</span
          >
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar"
            class="col-md-4"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template #body-cell-delete="props">
          <q-td>
            <q-btn
              round
              icon="sym_o_delete"
              color="red"
              flat
              @click="remove(props.rowIndex)"
            />
          </q-td>
        </template>

        <template #body-cell-compra_sugerida="props">
          <q-td>
            <q-input dense outlined v-model="props.row.compra_sugerida" />
          </q-td>
        </template>
      </q-table>
    </div>

    <div class="row col-12 q-mt-xl q-ml-md">
      <span
        class="row col-12 text-brand-1 text-weight-bold"
        style="font-size: 16px"
        >Digite um histórico para a requisição se necessário for:</span
      >
      <q-input
        class="q-mt-sm col-md-6 col-sm-12"
        dense
        outlined
        type="textarea"
        v-model="observacao"
      />

      <div class="row col-12 q-mt-md">
        <q-btn
          @click="finalDialog = true"
          class="q-mr-sm"
          :disable="centro?.name == undefined || solicitante?.name == undefined"
          no-caps
          icon="done"
          label="Criar Nova Necessidade"
          style="color: white; background-color: #304f78"
        >
          <q-tooltip
            class="bg-brand-1 text-body2"
            v-if="centro?.name == undefined || solicitante?.name == undefined"
            anchor="top middle"
            self="bottom middle"
            :offset="[10, 10]"
          >
            Selecione o Centro e o Solicitante no Topo da Tela
          </q-tooltip>
        </q-btn>
      </div>

      <dialog-info-design
        class="row col-12"
        mensagem="Detalhes Necessidade Compra"
        sub-mensagem="Preencha os dados abaixo para complementar as informações e auxiliar no processo de compras."
        :showConteudo="true"
        :showCancelar="true"
        :exibir="finalDialog"
        :desabilitarConfirme="
          finalDialogForm.data_aplicacao == '' ||
          finalDialogForm.justificativa_contratacao == ''
        "
        @resultado="resultadoDialog"
      >
        <div>
          <div class="q-ml-sm texto-titulo-input">Data de Aplicação *</div>
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="finalDialogForm.data_aplicacao"
            mask="##/##/####"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="finalDialogForm.data_aplicacao"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div>
          <div class="q-ml-sm texto-titulo-input">
            Justificativa Contratação *
          </div>
          <q-input
            v-model="finalDialogForm.justificativa_contratacao"
            dense
            outlined
            type="textarea"
            class="input input-new-design"
          />
        </div>
        <div>
          <div class="q-ml-sm texto-titulo-input">Detalhamento Técnico</div>
          <q-input
            v-model="finalDialogForm.detalhamento_tecnico"
            dense
            outlined
            type="textarea"
            class="input input-new-design"
          />
        </div>
        <div>
          <div class="q-ml-sm texto-titulo-input">
            Responsabilidades Fornecedores
          </div>
          <q-input
            v-model="finalDialogForm.responsabilidades_fornecedores"
            dense
            outlined
            type="textarea"
            class="input input-new-design"
          />
        </div>
        <div>
          <div class="q-ml-sm texto-titulo-input">
            Responsabilidades Contratante
          </div>
          <q-input
            v-model="finalDialogForm.responsabilidades_contratante"
            dense
            outlined
            type="textarea"
            class="input input-new-design"
          />
        </div>
        <div>
          <div class="q-ml-sm texto-titulo-input">Possíveis Fornecedores</div>
          <q-input
            v-model="finalDialogForm.possiveis_fornecedores"
            dense
            outlined
            type="textarea"
            class="input input-new-design"
          />
        </div>
      </dialog-info-design>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "product_code",
    label: "Código do Produto",
    field: "product_code",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "product_name",
    label: "Descrição",
    field: "product_name",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "measurement_unit",
    label: "Unidade de Medida",
    field: "measurement_unit",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "amount",
    label: "Estoque Atual",
    field: "amount",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "replacement_amount",
    label: "Ponto de Reposição",
    field: "replacement_amount",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "minimal_amount",
    label: "Estoque Crítico",
    field: "minimal_amount",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "max_amount",
    label: "Estoque Máximo",
    field: "max_amount",
    align: "left",
    style: "white-space: normal",
  },

  {
    name: "quantidade_em_aberto_necessidade",
    label: "Necessidade em Aberto",
    field: "quantidade_em_aberto_necessidade",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "compra_em_aberto",
    label: "Compra em Aberto",
    field: "compra_em_aberto",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "compra_sugerida",
    label: "Compra Sugerida",
    field: "compra_sugerida",
    align: "left",
    style: "white-space: normal",
  },
];

const columns2 = [
  {
    name: "delete",
    label: "Remover",
    field: "delete",
    align: "left",
  },

  {
    name: "product_code",
    label: "Código",
    field: "product_code",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "product_name",
    label: "Descrição",
    field: "product_name",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "measurement_unit",
    label: "Unidade de Medida",
    field: "measurement_unit",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "amount",
    label: "Estoque",
    field: "amount",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "compra_sugerida",
    label: "Quantidade Compra",
    field: "compra_sugerida",
    align: "left",
    style: "white-space: normal",
  },
];

import { watch, computed, onMounted } from "vue";
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
// import CentroCustoTable from "../components/CentroCustoTable.vue";
// import SolicitanteTable from "../components/SolicitanteTable.vue";
import SelectSolicitante from "../components/SelectSolicitante.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
// import GruposTable from "../components/GruposTable.vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
// import RequisitanteTable from "../components/RequisitanteTable.vue";
import SelectCentroCustos from "../components/SelectCentroCustos.vue";
import SelectSolicitanteCompra from "../components/SelectSolicitanteCompra.vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
import { date } from "quasar";
import PageHeader from "../../../../components/PageHeader.vue";
//import SelectGrupos from "../components/SelectGrupos.vue";

export default {
  components: {
    // CentroCustoTable,
    SelectCentroCustos,
    // SolicitanteTable,
    //SelectGrupos,
    SelectSolicitante,
    // GruposTable,
    SelectSolicitanteCompra,
    // RequisitanteTable,
    ListaUnidadesSelect,
    DialogInfoDesign,
    PageHeader,
  },
  setup() {
    const quasar = useQuasar();
    const router = useRouter();
    const store = useStore();
    const disable = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 25,
      rowsNumber: 25,
    });
    const selected = ref([]);
    const urgencia = ref("");
    const centro = ref("");
    const filtrosLista = ref({
      compra_sugerida: "",
      compra_em_aberto: "",

      stock: "",
    });
    const solicitante = ref("");
    const grupos = ref("");
    const responsavel = ref("");
    const rows = ref([]);
    const unidade = ref();
    const filter = ref("");
    const selecionados = ref([]);
    const produtosSelecionados = ref([]);
    const observacao = ref("");
    const todos = ref(false);
    const filtrar = ref("");
    const finalDialog = ref(false);
    const finalDialogForm = ref({
      data_aplicacao: "",
      justificativa_contratacao: "",
      detalhamento_tecnico: "",
      responsabilidades_fornecedores: "",
      responsabilidades_contratante: "",
      possiveis_fornecedores: "",
    });
    const myLocale = {
      days: "Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split(
        "_"
      ),
      daysShort: "Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),
      months:
        "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
          "_"
        ),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      firstDayOfWeek: 1,
    };
    const resultadoDialog = async (resultado) => {
      finalDialog.value = false;
      if (resultado) {
        await criarNecessidade();
      }
    };

    const receberSolicitante = async (value) => {
      solicitante.value = value;
    };

    const receberCentro = async (value) => {
      centro.value = value;
    };

    const receberGrupo = async (value) => {
      grupos.value = value;
    };

    const receberRequisitante = async (value) => {
      responsavel.value = value;
    };

    const getProdutos = async (page = 1, rowsPerPage = 25) => {
      disable.value = true;
      try {
        const response = await store.dispatch("compras/listarCompras", {
          vendor_id: store.state.org.unidadeData.id,
          search: filter.value,
          page,
          per_page: rowsPerPage,
          grupo_id: grupos.value?.id,
          compra_em_aberto: filtrosLista.value.compra_em_aberto,
          stock: filtrosLista.value.stock,
          compra_sugerida: filtrosLista.value.compra_sugerida,
        });

        rows.value = response.data.results.data;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;
        disable.value = false;
      } catch (error) {
        disable.value = false;
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getProdutos);

    watch(
      () => grupos.value,
      () => {
        getProdutos();
      }
    );

    watch(
      () => selecionados.value,
      () => {
        produtosSelecionados.value = selecionados.value;
      }
    );

    const criarNecessidade = async () => {
      let produtos = [];

      produtosSelecionados.value.forEach((e) => {
        produtos.push({
          codigo: e.product_code,
          id: e.product_id,
          responsavel_id: responsavel.value?.id,
          quantidade: Number(e.compra_sugerida.replace(",", ".")),
        });
      });

      try {
        await store.dispatch("compras/criarNecessidade", {
          vendor_id: store.state.org.unidadeData.id,
          cost_center_id: centro.value?.id,
          solicitante_id: solicitante.value?.id,
          tag_id: urgencia.value?.value,
          produtos: produtos,
          observacao: observacao.value,
          data_aplicacao: finalDialogForm.value.data_aplicacao
            ? date.formatDate(
                date.extractDate(
                  finalDialogForm.value.data_aplicacao,
                  "DD/MM/YYYY"
                ),
                "YYYY-MM-DD"
              )
            : undefined,
          detalhamento_tecnico:
            finalDialogForm.value.detalhamento_tecnico || undefined,
          responsabilidades_fornecedores:
            finalDialogForm.value.responsabilidades_fornecedores || undefined,
          responsabilidades_contratante:
            finalDialogForm.value.responsabilidades_contratante || undefined,
          possiveis_fornecedores:
            finalDialogForm.value.possiveis_fornecedores || undefined,
          justificativa_contratacao:
            finalDialogForm.value.justificativa_contratacao || undefined,
        });

        quasar.notify({
          message: "Necessidade criada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        router.push({
          name: "compras-necessidades",
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao criar a necessidade",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const criarNecessidadeRequisicao = async () => {
      let produtos = [];
      let voucher = [];

      produtosSelecionados.value.forEach((e) => {
        produtos.push({
          codigo: e.produto_codigo,
          id: e.produto_id,
          responsavel_id: responsavel.value.id,
          quantidade: e.amount,
        });
      });

      produtosSelecionados.value.forEach((e) => {
        voucher.push({
          codigo: e.produto_codigo,
          id: e.produto_id,
          responsavel_id: responsavel.value.id,
          quantidade: e.quantidade,
          amount: e.amount,
        });
      });
      try {
        await store.dispatch("compras/criarNecessidadeRequisicao", {
          vendor_id: store.state.org.unidadeData.id,
          cost_center_id: centro.value?.id,
          plantiff_id: solicitante.value?.id,
          products: voucher,
        });

        const response = await store.dispatch("compras/criarNecessidade", {
          vendor_id: store.state.org.unidadeData.id,
          cost_center_id: centro.value?.id,
          solicitante_id: solicitante.value?.id,
          tag_id: urgencia.value?.value,
          produtos: produtos,
        });

        quasar.notify({
          message: "Criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({
          name: "compras-detalhe",
          params: { id: response.data.result.uuid },
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const remove = async (index) => {
      produtosSelecionados.value.splice(index, 1);
    };

    watch(
      () => todos.value,
      () => {
        if (!todos.value) {
          rows.value = [];
          selecionados.value = [];
          return;
        }
        getProdutos();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        getProdutos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => pagination.value.rowsPerPage,
      () => {
        getProdutos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => filter.value,
      () => {
        getProdutos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => filtrosLista.value,
      () => {
        getProdutos(pagination.value.page, pagination.value.rowsPerPage);
      },
      { deep: true }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        getProdutos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    return {
      options: [
        {
          label: "Normal",
          value: 1,
        },
        {
          label: "Urgente",
          value: 2,
        },
        {
          label: "Máquina Parada",
          value: 3,
        },
      ],
      urgencia,
      receberCentro,
      centro,
      receberSolicitante,
      solicitante,
      receberGrupo,
      grupos,
      getProdutos,

      compraSugerida: [
        { label: "Todos", value: undefined },
        { label: "Sim", value: 1 },
        { label: "Não", value: 0 },
      ],
      compraAberto: [
        { label: "Todos", value: undefined },
        { label: "Sim", value: 1 },
        { label: "Não", value: 0 },
      ],
      mrpSelect: [
        { label: "Abaixo Minimo", value: "lower_min" },
        { label: "Abaixo Critico", value: "lower_crit" },
        { label: "Acima Maximo", value: "max_amount" },
      ],
      linhasPorPagina: [25, 50, 100, 500],
      rows,
      columns,
      filter,
      selected,
      disable,
      pagination,
      selecionados,
      receberRequisitante,
      responsavel,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      produtosSelecionados,
      columns2,
      observacao,
      criarNecessidade,
      remove,
      criarNecessidadeRequisicao,
      todos,
      filtrar,
      unidade,
      filtrosLista,
      finalDialog,
      finalDialogForm,
      myLocale,
      resultadoDialog,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
tbody tr td {
  white-space: pre-wrap;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}

.my-sticky-dynamic .q-table__container {
  overflow-y: auto;
  max-height: 500px; /* Altere conforme necessário */
}

@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>

<style>
.my-sticky-dynamic thead th {
  position: sticky;
  top: 0;
  z-index: 1; /* Certifique-se que está acima do conteúdo */
  background-color: #d9effc; /* Para corresponder ao estilo do header */
}
.texto-titulo {
  font-size: 20px;
}
</style>
